module.exports = __webpack_public_path__ + "media/B_L15.ac109f31.mp3";